import React from "react";
import { IMdaeAddButtonProps } from ".";
import MdaeButton from "../button";
import "./index.scss";

const MdaeAddButton: React.FC<IMdaeAddButtonProps> = (props) => {
  return (
    <div>
      <MdaeButton
        {...props}
        id={props.id}
        role={"dxButton"}
        icon="fa fa-plus application-section-primary-color"
        text={""}
        elementAttr={{
          id: props.id,
          class: "align-items-center mdae-header-add-buttons ",
          title: props.title,
        }}
      ></MdaeButton>
    </div>
  );
};
export default MdaeAddButton;
